import React from 'react';
import { Controller } from 'react-hook-form';

import { Textarea } from '../index';

const OpeningHoursField = ({
   containerClassName,
   textareaClassName,
   fieldName = '',
   label = '',
   placeholder = '',
   control
}) => {

  return (
    <div className={containerClassName}>
      <Controller
        control={control}
        name={fieldName}
        rules={{ minLength: 3 }}
        render={({ field: { onChange, value } }) => (
          <Textarea
            label={label}
            value={value}
            onChange={onChange}
            id={fieldName}
            placeholder={placeholder}
            isValidation={false}
            textareaClassName={textareaClassName}
          />
        )}
      />
    </div>
  )
}

export default OpeningHoursField;
